import styles from './AdvantagesContent.module.scss';

export const AdvantagesContent = () => {
  return (
    <div className={styles.container}>
      <img
        className={styles.advantagesTopContent}
        src="/images/Advantages/topContent-v2.webp"
        alt="advantagesContent"
      />
      <img
        className={styles.advantagesCenterContent}
        src="/images/Advantages/centerContent-v2.webp"
        alt="advantagesContent"
      />
    </div>
  );
};
